import { cn } from "@/lib/utils";

interface ChipOption {
  id: string;
  label: string;
}

interface ChipToggleGroupProps {
  options: readonly ChipOption[];
  selected: string[];
  onToggle: (id: string) => void;
  variant: "green" | "red";
  disabled?: boolean;
}

/** Qualification checklist chips — toggle to add/remove an id from the array. */
export function ChipToggleGroup({
  options,
  selected,
  onToggle,
  variant,
  disabled,
}: ChipToggleGroupProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = selected.includes(opt.id);
        return (
          <button
            key={opt.id}
            type="button"
            disabled={disabled}
            onClick={() => onToggle(opt.id)}
            aria-pressed={active}
            className={cn(
              "inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-medium transition-colors",
              "disabled:cursor-not-allowed disabled:opacity-50",
              active
                ? variant === "green"
                  ? "border-success bg-success-light text-success"
                  : "border-danger bg-danger-light text-danger"
                : "border-transparent bg-bg-muted text-text-secondary hover:bg-bg-hover",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
